// extracted by mini-css-extract-plugin
export default {"page-button-container":"Pager_page-button-container__oKrSA","page-button":"Pager_page-button__gmz+n"};